// extracted by mini-css-extract-plugin
export default {"AboutUs":"Home_AboutUs__-U7id","AboutUsContent":"Home_AboutUsContent__Pa0iG"};